import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";
import * as serviceWorker from './serviceWorker';
import 'form-request-submit-polyfill'

import 'bootstrap/dist/css/bootstrap.min.css';
import 'admin-lte/dist/css/adminlte.min.css';

import App from './app';

import 'bootstrap'
import 'admin-lte'


import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { reenviarEvento } from './components/page/form/control';

library.add(fas, far, fab);

export const env = (env => env === "release" ? "production" : env)((process.env.REACT_APP_ENV || process.env.NODE_ENV).toLowerCase())

const isDebug = (new URLSearchParams(window.location.search)).has('_debug')
console.log("env", env, isDebug ? "debug" : "", process.env.REACT_APP_ENV, process.env.NODE_ENV, "!");

export const debugEnv = isDebug || env !== 'production'

window.consoleLog = console.log


if (debugEnv) {
	console.log = console.debug
} else {
	console.log = () => { };
}

const rootElm = document.getElementById('root');

document.getElementsByTagName('body').item(0).addEventListener("keydown", event => {

	const form = document.getElementsByTagName("form").item(0)

	if (form && event.target !== form && !event.target.form) {
		reenviarEvento(event, form);
	}

})

ReactDOM.render((
	<Router>
		<App />
	</Router>

), rootElm);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
